import React from "react";
import { Button, Card, CardBody, Col, Input, Row } from "reactstrap";
import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
import { useDispatch, useSelector } from "react-redux";

import { setFromDate, setToDate, setGroupBy } from "../../reducers/posAnalyticsSlice";
import moment from "moment";

const PosDataFilter = ({groupBy = true, addButton = false, onAddClick, groupByModes}) => {
    const dispatch = useDispatch();
    const fromDate = useSelector((state) => state.posAnalyticsReducer.fromDate);
    const toDate = useSelector((state) => state.posAnalyticsReducer.toDate);
    const groupByMode = useSelector((state) => state.posAnalyticsReducer.groupBy);

    let cols = 6
    let extraCols = 0
    let groupByCols = 8
    let addButtonCols = 4

    if(groupBy && addButton) {
      cols = 4
      extraCols = 4
    } else {
      if(groupBy) {
        cols = 4
        extraCols = 4
        groupByCols = 12
      }
      if(addButton) {
        cols = 4
        extraCols = 4
        addButtonCols = 12 
      }
    }

    const onAdd = () => {
      if(onAddClick) onAddClick()
    }

    return (
      <Card>
        <CardBody>
          <Row>
            <Col sm="12" md={cols}>
                <div>
                  <span>Data inizio</span>
                  <Datetime
                    dateFormat="DD/MM/YYYY"
                    timeFormat={false}
                    closeOnSelect={true}
                    value={fromDate}
                    inputProps={{ placeholder: "seleziona una data..." }}
                    onChange={(value) => {
                      // console.log(value.format("YYYY/MM/DD"))
                      if(value instanceof moment) {
                        dispatch(setFromDate(value))
                      }
                    }}
                  />
                </div>
            </Col>
            <Col sm="12" md={cols}>
              <div>
                <span>Data fine</span>
                <Datetime
                  dateFormat="DD/MM/YYYY"
                  timeFormat={false}
                  closeOnSelect={true}
                  value={toDate}
                  inputProps={{ placeholder: "seleziona una data..." }}
                  onChange={(value) => {
                    //console.log(value.format("YYYY/MM/DD hh:mm:ss"))
                    if(value instanceof moment) {
                      dispatch(setToDate(value))
                    }
                  }}
                />
              </div>
            </Col>
            {
              groupBy || addButton 
              ? <Col sm="12" md={extraCols}>
                <Row>
                  {
                    groupBy 
                    ? <Col sm="12" md={groupByCols}>
                        <span>Raggruppamento</span>
                        <Input type="select" id="group_by" 
                          value={groupByMode} 
                          onChange={(e) => dispatch(setGroupBy(e.target.value))} 
                        >
                          {groupByModes.map((groupBy) => (
                            <option key={groupBy.value} value={groupBy.value}>{groupBy.label}</option>
                          ))}
                          {/* <option value={PosAnalyticsModel.GROUP_DAILY}>giornaliero</option>
                          <option value={PosAnalyticsModel.GROUP_MONTHLY}>mensile</option>
                          <option value={PosAnalyticsModel.GROUP_YEARLY}>annuale</option> */}
                        </Input>
                      </Col>
                    : null
                  }
                  {
                    addButton 
                    ? <Col sm="12" md={addButtonCols}>
                        <div>&nbsp;</div>
                        <Button id="new_pos_btn" color="primary" onClick={onAdd} >
                          <span className="fas fa-plus"></span>
                        </Button>
                      </Col>
                    : null
                  }
                </Row>
              </Col>
              : null
            }
          </Row>
        </CardBody>
      </Card>
      // <InputSearch 
      //   placeholder="Search point of sales..."
      //   onChange={ (value) => {
      //     dispatch(setTerm(value))
      //   } }
      // />      
    );
};

export default PosDataFilter;